function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
//Limitless imports
import { OkCancelDialog, PortalTextInput } from "../../..";
import { isFieldEmpty } from "@limitless/common/utils";
class NewCategoryDialog extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      userCategory: this.props.category,
      userSubCategory: this.props.subCategory
    });
  }
  render() {
    const {
      classes,
      onSaveCategory,
      onCancelClick,
      showSubCategoryInput,
      secondaryTitle,
      primaryTitle,
      okLabel
    } = this.props;
    const {
      userCategory,
      userSubCategory
    } = this.state;
    const {
      fieldErrors
    } = this.props.validateForm({
      category: userCategory,
      subCategory: userSubCategory
    });
    return /*#__PURE__*/React.createElement(OkCancelDialog, {
      title: primaryTitle,
      okLabel: okLabel,
      onCancelClick: onCancelClick,
      onOKClick: () => onSaveCategory(userCategory, userSubCategory),
      dialogProps: {
        onBackdropClick: onCancelClick
      },
      dialogTitleProps: {
        classes: {
          root: classes.dialog
        }
      },
      dialogContentProps: {
        classes: {
          root: classes.dialogContentContainer
        }
      },
      okDisabled: !!(isFieldEmpty(userCategory) || fieldErrors.category || fieldErrors.subCategory)
    }, /*#__PURE__*/React.createElement(Typography, null, secondaryTitle), /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        width: 250,
        marginRight: 8
      }
    }, /*#__PURE__*/React.createElement(PortalTextInput, {
      label: "Category",
      onChange: event => this.setState({
        userCategory: event.target.value
      }),
      value: userCategory,
      id: "categoryNameInput",
      variant: "outlined",
      fullWidth: true,
      placeholder: "Enter a category name",
      autoFocus: true,
      isMandatory: true,
      inputProps: {
        className: classes.input
      },
      error: !!fieldErrors.category,
      helperText: fieldErrors.category
    })), showSubCategoryInput && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        width: 250,
        marginRight: 8
      }
    }, /*#__PURE__*/React.createElement(PortalTextInput, {
      label: "Sub Category",
      onChange: event => this.setState({
        userSubCategory: event.target.value
      }),
      value: userSubCategory,
      id: "subCategoryNameInput",
      variant: "outlined",
      fullWidth: true,
      placeholder: "Enter a sub category name",
      inputProps: {
        className: classes.input
      },
      error: !!fieldErrors.subCategory,
      helperText: fieldErrors.subCategory
    }))));
  }
}
const styles = theme => ({
  dialog: {
    paddingBottom: 0
  },
  input: {
    backgroundColor: theme.background.paper,
    fontSize: "0.875rem"
  },
  dialogContentContainer: {
    padding: "16px !important",
    margin: 16,
    backgroundColor: theme.background.default
  }
});
export default withStyles(styles)(NewCategoryDialog);
NewCategoryDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onSaveCategory: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  category: PropTypes.string,
  subCategory: PropTypes.string,
  showSubCategoryInput: PropTypes.bool,
  secondaryTitle: PropTypes.string,
  primaryTitle: PropTypes.string,
  okLabel: PropTypes.string,
  validateForm: PropTypes.func
};
NewCategoryDialog.defaultProps = {
  category: "",
  subCategory: "",
  secondaryTitle: "This will allow other Knowledge Users to select it when creating new articles",
  primaryTitle: "Create a new category",
  okLabel: "Save",
  showSubCategoryInput: true,
  validateForm: () => ({})
};